import React from 'react';

import cx from 'classnames';

import s from './DynamicHeadingLine.module.scss';

type DynamicHeadingLineProps = {
  colour: string;
  width?: string;
  marginSmall?: boolean;
  className?: string;
};
const DynamicHeadingLine: React.FC<DynamicHeadingLineProps> = ({
  colour,
  width,
  marginSmall,
  className,
  ...props
}) => {
  return (
    <div
      style={{ backgroundColor: colour, width }}
      className={cx(
        s.headingLine,
        {
          [s.marginSmall]: marginSmall,
        },
        className,
      )}
      {...props}
    />
  );
};

export default DynamicHeadingLine;
